import AccountLoginPage from "@/views/account/AccountLoginPage.vue";
import NaverRedirectPage from "@/views/account/NaverRedirectPage.vue";
import KakaoRedirectPage from "@/views/account/KakaoRedirectPage.vue";
import AccountSignupPage from "@/views/account/AccountSignupPage.vue";
import NaverConnectRedirectPage from "@/views/account/NaverConnectRedirectPage.vue";
import KakaoConnectRedirectPage from "@/views/account/KakaoConnectRedirectPage.vue";

const accountRoutes = [
  {
    path: "/login",
    name: "AccountLoginPage",
    component: AccountLoginPage,
  },
  {
    path: "/login/oauth2/code/naver",
    name: "NaverRedirectPage",
    component: NaverRedirectPage,
  },
  {
    path: "/login/oauth2/code/kakao",
    name: "KakaoRedirectPage",
    component: KakaoRedirectPage,
  },
  {
    path: "/connect/oauth2/code/naver",
    name: "NaverConnectRedirectPage",
    component: NaverConnectRedirectPage,
  },
  {
    path: "/connect/oauth2/code/kakao",
    name: "KakaoConnectRedirectPage",
    component: KakaoConnectRedirectPage,
  },
  {
    path: "/signup",
    name: "AccountSignupPage",
    component: AccountSignupPage,
  },
]

export default accountRoutes;